import React from "react";
import { Button, Modal } from "semantic-ui-react";
import useAuthorisation from "../hooks/useAuthorisation";
import useEventDetailsGrid from "../../../hooks/useEventDetailsGrid";
import ComplianceClient from "@common/api/ComplianceClient";
import AlertModalAction from "@common/redux/actions/AlertModalAction";
import { handleError } from "@common/components/helpers/error";
import TextComponent from "../shared/forms/TextComponent";
import AuthorisationModalAction from "@common/redux/actions/AuthorisationModalAction";
import { getCurrentDateTime } from "../helpers/datetime";

const AuthorisationModal = () => {
  const { open, comments, maxLength, onChange } = useAuthorisation();

  const { activeRow, onRefresh } = useEventDetailsGrid();

  const onAuthoriseClick = () => {
    if (!activeRow) return;
    ComplianceClient.ReadForAuthorise(activeRow?.id).then(({ rowVersion }) => {
      ComplianceClient.Authorise(
        activeRow?.id,
        rowVersion,
        getCurrentDateTime(),
        comments,
      )
        .then(
          () =>
            AlertModalAction.open(
              "The compliance record was successfully authorised!",
              "Success",
              () => onRefresh(),
            ),
          handleError,
        )
        .finally(AuthorisationModalAction.reset);
    });
  };

  return (
    <Modal
      closeIcon
      size="small"
      open={open}
      onClose={AuthorisationModalAction.reset}
    >
      <Modal.Header>Authorisation</Modal.Header>
      <Modal.Content>
        <TextComponent
          name="comments"
          label="Comments"
          placeholder="Comments..."
          value={comments}
          onChange={onChange}
          maxLength={maxLength}
        />
      </Modal.Content>
      <Modal.Actions>
        <div>
          <Button
            content="Authorise"
            color="blue"
            icon="check"
            onClick={onAuthoriseClick}
            disabled={comments.length > maxLength}
          />
          <Button
            content="Back"
            icon="angle left"
            floated="left"
            onClick={AuthorisationModalAction.reset}
          />
        </div>
      </Modal.Actions>
    </Modal>
  );
};

export default AuthorisationModal;
